var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-observer',{attrs:{"tag":"div"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var invalid = ref.invalid;
return [_c('text-input',{attrs:{"setup":{
      'func': _vm.inputConfigSetup,
      'args': {
        'model': _vm.companyData.company,
        'key': 'organization_name',
        'validation': 'required',
        'prefix': 'company_registration_',
      },
    }}}),_c('text-input',{attrs:{"setup":{
      'func': _vm.inputConfigSetup,
      'args': {
        'model': _vm.companyData.company,
        'key': 'person_name',
        'validation': 'required',
        'prefix': 'company_registration_',
      },
    }}}),_c('text-input',{attrs:{"setup":{
      'func': _vm.inputConfigSetup,
      'args': {
        'model': _vm.companyData.company,
        'key': 'person_type',
        'validation': 'required',
        'prefix': 'company_registration_',
      },
    }}}),_c('text-input',{attrs:{"setup":{
      'func': _vm.inputConfigSetup,
      'args': {
        'model': _vm.companyData.company,
        'key': 'base_type',
        'validation': 'required',
        'prefix': 'company_registration_',
      },
    }}}),_c('text-input',{attrs:{"setup":{
      'func': _vm.inputConfigSetup,
      'args': {
        'model': _vm.companyData.company,
        'key': 'organization_inn',
        'validation': 'required',
        'prefix': 'company_registration_',
      },
    }}}),_c('text-input',{attrs:{"setup":{
      'func': _vm.inputConfigSetup,
      'args': {
        'model': _vm.companyData.company,
        'key': 'organization_kpp',
        'validation': 'required',
        'prefix': 'company_registration_',
      },
    }}}),_c('text-input',{attrs:{"setup":{
      'func': _vm.inputConfigSetup,
      'args': {
        'model': _vm.companyData.company,
        'key': 'organization_ogrn',
        'validation': 'required',
        'prefix': 'company_registration_',
      },
    }}}),_c('text-input',{attrs:{"setup":{
      'func': _vm.inputConfigSetup,
      'args': {
        'model': _vm.companyData.company,
        'key': 'organization_account',
        'validation': 'required',
        'prefix': 'company_registration_',
      },
    }}}),_c('text-input',{attrs:{"setup":{
      'func': _vm.inputConfigSetup,
      'args': {
        'model': _vm.companyData.company,
        'key': 'organization_bank_account',
        'validation': 'required',
        'prefix': 'company_registration_',
      },
    }}}),_c('text-input',{attrs:{"setup":{
      'func': _vm.inputConfigSetup,
      'args': {
        'model': _vm.companyData.company,
        'key': 'organization_bank',
        'validation': 'required',
        'prefix': 'company_registration_',
      },
    }}}),_c('text-input',{attrs:{"setup":{
      'func': _vm.inputConfigSetup,
      'args': {
        'model': _vm.companyData.company,
        'key': 'organization_bik',
        'validation': 'required',
        'prefix': 'company_registration_',
      },
    }}}),_c('text-input',{attrs:{"setup":{
      'func': _vm.inputConfigSetup,
      'args': {
        'model': _vm.companyData.company,
        'key': 'organization_address_index',
        'validation': 'required',
        'prefix': 'company_registration_',
      },
    }}}),_c('text-input',{attrs:{"setup":{
      'func': _vm.inputConfigSetup,
      'args': {
        'model': _vm.companyData.company,
        'key': 'organization_address',
        'validation': 'required',
        'prefix': 'company_registration_',
      },
    }}}),_c('text-input',{attrs:{"setup":{
      'func': _vm.inputConfigSetup,
      'args': {
        'model': _vm.companyData.company,
        'key': 'organization_mail_address_index',
        'validation': 'required',
        'prefix': 'company_registration_',
      },
    }}}),_c('text-input',{attrs:{"setup":{
      'func': _vm.inputConfigSetup,
      'args': {
        'model': _vm.companyData.company,
        'key': 'organization_mail_address',
        'validation': 'required',
        'prefix': 'company_registration_',
      },
    }}}),_c('text-input',{attrs:{"setup":{
      'func': _vm.inputConfigSetup,
      'args': {
        'model': _vm.companyData.company,
        'key': 'organization_phone',
        'validation': 'required',
        'prefix': 'company_registration_',
      },
    }}}),_c('agreement-checkbox-input',{attrs:{"setup":{
      'func': _vm.inputConfigSetup,
      'args': {
        'model': _vm.companyData.agreements,
        'key': 'valid_age',
        'prefix': 'company_registration_',
        'validation': 'always_true',
      },
    }}}),_c('agreement-checkbox-input',{attrs:{"setup":{
      'func': _vm.inputConfigSetup,
      'args': {
        'model': _vm.companyData.agreements,
        'key': 'offer_check',
        'prefix': 'company_registration_',
        'validation': 'always_true',
      },
    }}}),_c('a',{staticClass:"inline-block mb-4",attrs:{"href":_vm.legalLink,"target":"_blank"}},[_vm._v(" "+_vm._s(_vm.$t('company_registration_docs_link_title'))+" ")]),_c('agreement-checkbox-input',{attrs:{"setup":{
      'func': _vm.inputConfigSetup,
      'args': {
        'model': _vm.companyData.agreements,
        'key': 'privacy_agreement',
        'prefix': 'company_registration_',
        'validation': 'always_true',
      },
    }}}),_c('div',{staticClass:"flex flex-row items-center justify-end mt-5"},[_c('a-button',{staticClass:"mr-2",on:{"click":function($event){return _vm.$emit('next', { 'step': _vm.CompanyRegistrationStep.PowerOfAttorney, })}}},[_vm._v(" "+_vm._s(_vm.$t('company_registration_button_back'))+" ")]),_c('a-button',{attrs:{"type":"primary","disabled":invalid},on:{"click":_vm.onNextButtonClick}},[_vm._v(" "+_vm._s(_vm.$t('company_registration_button_next'))+" ")])],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }